import React, { useEffect, useState } from "react";
import "./PrivacyPolicy.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import CountUp from "react-countup";
import ScrollTrigger from "react-scroll-trigger";
import { getAssetPath } from "../../services/helpers";
import { useNavigate } from "react-router-dom";

import { useTranslation } from "react-i18next";
import {
    getLocalStorageData,
    storeData,
} from "../../services/localStorageService";

const PrivacyPolicy = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [counterOn, setCounterOn] = useState(false);
    const [seasonSelected, setSeasonSelected] = useState(null);
    const {
        PrivacyPolicyBanner,
        PrivacyPolicyCotent
    } = t("PrivacyPolicy");

    useEffect(() => {
        fetch("/assets/data.json")
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {
                setSeasonSelected(data[data.length - 1]);
                const reversedData = data.slice().reverse();
                setData(reversedData);
            })
            .catch((error) => {
                console.error("Error fetching data:", error);
            });
    }, []);

    const handleButtonClick = () => {
        if (
            getLocalStorageData("token") &&
            parseInt(getLocalStorageData("roleId"), 10) === 2
        ) {
            navigate("/Tenders");
        } else {
            navigate("/OfflineTender");
        }
    };

    const handleSeasonDateSelection = (season) => {
        setSeasonSelected(season);
    };

    return (
        <>
            <div className="Tenders-headbanner">
                <div className="Aboutus-banner col-md-12">
                    <div className="container">
                        <h1 className="headingtenders font-bold">
                            {PrivacyPolicyBanner.heading}
                        </h1>
                        <div className="breadcrum">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb bg-container">
                                    <li className="breadcrumb-item brdm-itm">
                                        <a href="/home">{PrivacyPolicyBanner.link1}</a>
                                    </li>
                                    <li className="breadcrumb-item brdm-itm">
                                        <a href="/home">{PrivacyPolicyBanner.link2}</a>
                                    </li>
                                    <li
                                        className="breadcrumb-item brdm-itm active"
                                        aria-current="page"
                                    >
                                        {PrivacyPolicyBanner.link3}
                                    </li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
            <section className="simple-idea abt-pdtop cane-deve-bg">
                <div class="container col-md-6">
                    <h2 class="idea-title">{PrivacyPolicyBanner.heading}</h2>
                </div>
                {/* Content */}
                <div className="privacy-section">
                    <div className="container">
                        <div className="privacy-card">
                            <div className="policy-block">
                                <div className="username investor-title">
                                    <h2 className="font-bold mb-0">{PrivacyPolicyCotent.Heading_1}</h2>
                                </div>
                                <p>{PrivacyPolicyCotent.CotentText_1}</p>
                            </div>

                            <div className="policy-block">
                                <div className="username investor-title">
                                    <h2 className="font-bold mb-0">{PrivacyPolicyCotent.Heading_2}</h2>
                                </div>
                                <p>{PrivacyPolicyCotent.CotentText_2}</p>
                            </div>

                            <div className="policy-block">
                                <div className="username investor-title">
                                    <h2 className="font-bold mb-0">{PrivacyPolicyCotent.Heading_3}</h2>
                                </div>
                                <p>{PrivacyPolicyCotent.CotentText_3}</p>
                            </div>

                            <div className="policy-block">
                                <div className="username investor-title">
                                    <h2 className="font-bold mb-0">{PrivacyPolicyCotent.Heading_4}</h2>
                                </div>
                                <p>{PrivacyPolicyCotent.CotentText_4}</p>
                            </div>

                            <div className="policy-block">
                                <div className="username investor-title">
                                    <h2 className="font-bold mb-0">{PrivacyPolicyCotent.Heading_5}</h2>
                                </div>
                                <p>{PrivacyPolicyCotent.CotentText_5}</p>
                            </div>

                            <div className="policy-block">
                                <div className="username investor-title">
                                    <h2 className="font-bold mb-0">{PrivacyPolicyCotent.Heading_6}</h2>
                                </div>
                                <p>{PrivacyPolicyCotent.CotentText_6}</p>
                            </div>

                            <div className="policy-block">
                                <div className="username investor-title">
                                    <h2 className="font-bold mb-0">{PrivacyPolicyCotent.Heading_7}</h2>
                                </div>
                                <p>{PrivacyPolicyCotent.CotentText_7}</p>
                            </div>

                            <div className="policy-block">
                                <div className="username investor-title">
                                    <h2 className="font-bold mb-0">{PrivacyPolicyCotent.Heading_8}</h2>
                                </div>
                                <p>{PrivacyPolicyCotent.CotentText_8}</p>
                            </div>

                            <div className="policy-block">
                                <div className="username investor-title">
                                    <h2 className="font-bold mb-0">{PrivacyPolicyCotent.Heading_9}</h2>
                                </div>
                                <p>{PrivacyPolicyCotent.CotentText_9}</p>
                            </div>

                            <div className="policy-block">
                                <div className="username investor-title">
                                    <h2 className="font-bold mb-0">{PrivacyPolicyCotent.Heading_10}</h2>
                                </div>
                                <p>{PrivacyPolicyCotent.CotentText_10}</p>
                            </div>

                            <div className="policy-block">
                                <div className="username investor-title">
                                    <h2 className="font-bold mb-0">{PrivacyPolicyCotent.Heading_11}</h2>
                                </div>
                                <p>{PrivacyPolicyCotent.CotentText_11}</p>
                            </div>

                            <div className="policy-block">
                                <div className="username investor-title">
                                    <h2 className="font-bold mb-0">{PrivacyPolicyCotent.Heading_12}</h2>
                                </div>
                                <p>{PrivacyPolicyCotent.CotentText_12}</p>
                            </div>

                            <div className="policy-block">
                                <div className="username investor-title">
                                    <h2 className="font-bold mb-0">{PrivacyPolicyCotent.Heading_13}</h2>
                                </div>
                                <p>{PrivacyPolicyCotent.CotentText_13}</p>
                            </div>


                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default PrivacyPolicy;
